import { apiGet, apiPost, apiPatch, apiDelete } from "./apiRequest";

export const getScheduleForDeviceService = async (deviceId, deviceType) => {
    const res = await apiGet(`/schedules?deviceId=${deviceId}&deviceType=${deviceType}`);
    return res?.data;
}

export const createScheduleService = async (data) =>
    apiPost("/schedules/", data);

export const updateScheduleService = async (id, data) =>
    apiPatch(`/schedules/${id}`, data);

export const deleteScheduleService = async (id) =>
    apiDelete(`/schedules/${id}`);
